import React, { useEffect, useState } from "react";
import theme from "./theme";
import Splash from "./pages/Splash";
import ManageFilters from "./pages/admin/ManageFilters";
import DashboardLayout from "./Layouts/DashboardLayout";
import Presentations from "./pages/Presentations";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { Route, Routes } from "react-router-dom";
//import Test from "./Test"
import SavedSearches from "./pages/SavedSearches";
import EditEmail from "./pages/email-generator/EditEmail";
import ScrollToTop from "./ScrollToTop";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import {
  getUser,
  getUserStatus,
  getUserError,
  fetchAuthUser,
} from "./store/userSlice";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import { defaultConfig, dynamicConfigUrl } from "./configuration/config";
import { useConfigs } from "./configuration/useConfigs";
import BrowseProductLaunches from "./pages/BrowseProductLaunches";
import CreateProductLaunch from "./pages/admin/CreateProductLaunch";
import EditProductLaunch from "./pages/admin/EditProductLaunch";
import AdminDashboard from "./pages/admin/AdminDashboard";

const configLoadingErrorMessage =
  "Error while fetching global config, the App wil not be rendered. (This is NOT a React error.)";
let HOSTNAME = "flavoriq.miron.services";
if (window.location.hostname==="marketwatch.flavoriq.global") HOSTNAME = "flavoriq.global";

export default function App() {
  const [loading, setLoading] = useState(true);
  const [loggedIn, setLoggedIn] = useState(false);

  const { setConfigs } = useConfigs();
  const [configLoadingState, setConfigLoadingState] = useState("loading");

  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      // Anything except 2XX goes to here
      const status = error.response?.status || 500;
      console.log("status:" + status);
      if (status === 401) {
        window.location = "https://" + HOSTNAME + "/auth";
        setLoading = true;
        setLoggedIn = false;
      } else {
        return Promise.reject(error);
      }
    }
  );

  const dispatch = useDispatch();
  const user = useSelector(getUser);
  const userStatus = useSelector(getUserStatus);
  const error = useSelector(getUserError);

  useEffect(() => {
    if (userStatus === "idle") {
      dispatch(fetchAuthUser());
    }

    axios
      .get(dynamicConfigUrl)
      .then((response) => {
        setConfigs(response.data);      
        setConfigLoadingState("ready");
      })
      .catch((e) => {
        if (process.env.NODE_ENV === "development") {
          console.log(
            `Failed to load global configuration from '${dynamicConfigUrl}', using the default configuration instead:`,
            defaultConfig
          );
          setConfigLoadingState("ready");
        } else {
          console.log(
            configLoadingErrorMessage,
            `Have you provided the config file '${dynamicConfigUrl}'?`,
            e
          );
          setConfigLoadingState("error");
        }
      });
  }, [setConfigs, userStatus, dispatch]);

  const checkAuth = () => {
    console.log("userStatus !!" + userStatus);
    if (userStatus === "suceeded") {
      setLoading(false);
      setLoggedIn(true);
    } else if (userStatus === "failed") {
      setLoading(true);
      setLoggedIn(false);
      window.location = "https://" + HOSTNAME + "/auth";
    }
  };

  if (userStatus !== "succeeded") {
    return (
      <>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justifyContent="center"
            style={{ minHeight: "100vh" }}
          >
            <CircularProgress color="success" />
          </Grid>
        </ThemeProvider>
      </>
    );
  }

  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ScrollToTop />
        <Routes>
          <Route element={<DashboardLayout />}>
            <Route
              path="/admin"
              element={user.isAdmin ? <AdminDashboard /> : <Splash />}
            />

            <Route
              path="/admin/manage-filters"
              element={
                user.isAdmin ? <ManageFilters /> : <Splash />
              }
            />

            <Route
              path="/admin/create-product-launch"
              element={user.isAdmin ? <CreateProductLaunch /> : <Splash />}
            />

            <Route
              path="/admin/edit-product-launch/:conceptId"
              element={user.isAdmin ? <EditProductLaunch /> : <Splash />}
            />
            <Route path="/product-launches" element={<BrowseProductLaunches />} />
            <Route path="/presentations" element={<Presentations />} />
            <Route path="/saved-searches" element={<SavedSearches />} />
            <Route path="/edit-email" element={<EditEmail />} />
          </Route>
          <Route path="/" element={<Splash />} />
        </Routes>
      </ThemeProvider>
    </>
  );
}
